import { NbMenuItem } from '@nebular/theme';
import { AuthService } from '../auth-service.service';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthMenuService {

  constructor(private authService: AuthService) { }

  setMenuItemsRights(menu: NbMenuItem[]): NbMenuItem[] {
    menu.forEach(item => {
      let hide: boolean = false;

      let hasClaim: boolean = true;
      let hasRoles: boolean = true;
      let hasSubscription: boolean = true;

      if (!!item.data) {
        if (!!item.data.requiredClaim) hasClaim = this.authService.userHasClaim(item.data.requiredClaim);
        if (!!item.data.requiredRoles) hasRoles = (this.authService.userHasRole(item.data.requiredRoles) || this.authService.userHasCustomerRole(item.data.requiredRoles));
      }

      if (!hasClaim || !hasRoles || !hasSubscription) hide = true;

      if (!hide) {
        if (!!item.children) {
          item.children.forEach((child) => {
            let hideChild: boolean = false;
            let hasChildClaim: boolean = true;
            let hasChildRoles: boolean = true;
            let hasChildSubscription: boolean = true;

            if (!!child.data) {
              if (!!child.data.requiredClaim) hasChildClaim = this.authService.userHasClaim(child.data.requiredClaim);
              if (!!child.data.requiredRoles) hasChildRoles = (this.authService.userHasRole(child.data.requiredRoles) || this.authService.userHasCustomerRole(child.data.requiredRoles));
            }

            if (!hasChildClaim || !hasChildRoles || !hasChildSubscription) hideChild = true;

            child.hidden = hideChild;
          });
        }
      }

      item.hidden = hide;
    });
    return menu;
  }

  /* 2025.03.03 GdV - Vervallen want door het opbouwen van een nieuw array werkt active menu niet meer
  getMenuItems(menu: NbMenuItem[]): NbMenuItem[] {
    let items = [];

    menu.forEach((item) => {
      let skip: boolean = false;

      let hasClaim: boolean = true;
      let hasRoles: boolean = true;
      let hasSubscription: boolean = true;

      if (!!item.data) {
        if (!!item.data.requiredClaim) hasClaim = this.authService.userHasClaim(item.data.requiredClaim);
        if (!!item.data.requiredRoles) hasRoles = (this.authService.userHasRole(item.data.requiredRoles) || this.authService.userHasCustomerRole(item.data.requiredRoles));
        //if(!!item.data.requiredSubscriptions) hasSubscription = this.authService.userHasSubscription(item.data.requiredSubscriptions);
      }

      if (!hasClaim || !hasRoles || !hasSubscription) skip = true;

      if (!skip) {
        if (!!item.children) {
          let children = [];
          item.children.forEach((child) => {
            let skipChild: boolean = false;
            let hasChildClaim: boolean = true;
            let hasChildRoles: boolean = true;
            let hasChildSubscription: boolean = true;

            if (!!child.data) {
              if (!!child.data.requiredClaim) hasChildClaim = this.authService.userHasClaim(child.data.requiredClaim);
              if (!!child.data.requiredRoles) hasChildRoles = (this.authService.userHasRole(child.data.requiredRoles) || this.authService.userHasCustomerRole(child.data.requiredRoles));
              //if(!!child.data.requiredSubscriptions) hasChildSubscription = this.authService.userHasSubscription(child.data.requiredSubscriptions);
            }

            if (!hasChildClaim || !hasChildRoles || !hasChildSubscription) skipChild = true;

            if (!skipChild) {
              children.push(child);
            }
          });
          item.children = children;
          if ((item.children.length > 0) || !!item.link) items.push(item);
        } else {
          items.push(item);
        }
      }

    });


    return items;
  }*/

}
